import React, { useContext } from 'react'
import handleViewport, { InjectedViewportProps } from 'react-in-viewport'
import { ContextConsole } from '@/components/ContextConsole'

const ConsoleComponent: React.FC = () => {
    const { consoleMessages } = useContext(ContextConsole)

    const Block = (props: InjectedViewportProps<HTMLDivElement>) => {
        return (
            <h4>
                Console Log
                <br />
                {consoleMessages.map((msg, index) => (
                    <span key={index + 1} style={{ color: getColor(msg.type) }}>
                        {msg.message}
                        <br />
                    </span>
                ))}
            </h4>
        )
    }

    const ViewportBlock = handleViewport(Block)

    return <ViewportBlock />
}

function getColor(type: 'log' | 'error' | 'warn'): string {
    switch (type) {
        case 'log':
            return 'white'
        case 'error':
            return 'red'
        case 'warn':
            return 'orange'
        default:
            return 'white'
    }
}

export default ConsoleComponent
